import Vue from 'vue';
import Vuex from 'vuex';
import loader from './modules/loader';
import staticListings from './modules/static-listings';
import singleContact from './modules/single-contact';
import singleBookings from './modules/single-bookings';
import selectedContacts from './modules/selected-contacts';
import me from './modules/me';
import updatedRelatives from './modules/updated-relatives';
import courseBooking from './modules/course-booking';
import singleCourse from './modules/single-course';
import tablesState from './modules/tables-state';
import settings from './modules/settings';
import fetchify from './modules/fetchify';
import websiteInfo from './modules/website-info';
import selectedBookings from './modules/selected-bookings';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    loader,
    staticListings,
    singleContact,
    selectedContacts,
    me,
    websiteInfo,
    updatedRelatives,
    courseBooking,
    singleCourse,
    tablesState,
    settings,
    fetchify,
    selectedBookings,
    singleBookings
  }
});
